import React, { useState } from "react"
import NumericCard from "./NumericCard"
import CardElement from "./CardElement"
import Tooltip from "src/components/tooltip"
/**
 * @param props {{
 *  scState:scState
 * }}
 */
export default function LeftSideCards({ scState }) {
  if (!scState.selectedResource || !scState.selectedResource.cards) return null
  var card = 1
  var steps = []
  steps.push({
    title: "Modifier decleration",
    content: <div>bla bla bla</div>,
  })
  steps.push({
    title: "Modifier decleration",
    content: <div>bla bla bla</div>,
  })
  var cards = scState.selectedResource.cards
  return (
    <div>
      <div
        css={`
          font-size: 24px;
          margin-top: 24px;
          background: #dedcdc;
          box-shadow: rgba(0, 0, 0, 0.25) 4px 4px 4px 0px;
          border-radius: 11px;
          padding: 5px 24px 5px 16px;
          position: sticky;
          top: 0;
          z-index: 998;
        `}
      >
        <span
          css={`
            font-weight: 200;
          `}
        >
          Analysis of the {scState.selectedResource.type}
        </span>{" "}
        <Tooltip
          tip={
            (
              scState.selectedResource.displayName ||
              scState.selectedResource.name
            ).length > 30 &&
            (scState.selectedResource.displayName ||
              scState.selectedResource.name)
          }
        >
          <b>
            {(
              scState.selectedResource.displayName ||
              scState.selectedResource.name
            ).length > 30
              ? `${(
                  scState.selectedResource.displayName ||
                  scState.selectedResource.name
                ).substring(0, 27)}...`
              : scState.selectedResource.displayName ||
                scState.selectedResource.name}
          </b>
        </Tooltip>
      </div>
      {cards.map((card, index) => (
        <div
          css={`
            margin-top: 24px;
            font-size: 18px;
          `}
          key={index}
        >
          <NumericCard id={card.id} number={index + 1} title={card.title}>
            {card.cardElements.map((x, idx) => (
              <CardElement key={idx} scState={scState} cardElement={x} cardId={card.id} />
            ))}
          </NumericCard>
        </div>
      ))}
    </div>
  )
}
